import React, { useRef } from 'react';
import Icon from '../../../components/AppIcon';

const PhotoUploadSection = ({ photos, onChange }) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = (e) => {
    const files = Array.from(e?.target?.files);
    const newPhotos = files?.map(file => ({
      id: Date.now() + Math.random(),
      name: file?.name,
      url: URL.createObjectURL(file),
      file
    }));
    onChange([...photos, ...newPhotos]);
  };

  const handleRemovePhoto = (id) => {
    onChange(photos?.filter(p => p?.id !== id));
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Photo/Video Evidence</h3>
      
      <div
        onClick={() => fileInputRef?.current?.click()}
        className="border-2 border-dashed border-border rounded-lg p-8 text-center cursor-pointer hover:border-primary transition-colors"
      >
        <Icon name="Upload" size={40} className="mx-auto text-muted-foreground mb-3" />
        <p className="text-foreground font-medium mb-1">Click to upload or drag and drop</p>
        <p className="text-sm text-muted-foreground">PNG, JPG, MP4 up to 10MB</p>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,video/*"
        multiple
        onChange={handleFileSelect}
        className="hidden"
      />

      {photos?.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
          {photos?.map((photo) => (
            <div key={photo?.id} className="relative group">
              <img
                src={photo?.url}
                alt={`Uploaded evidence ${photo?.name}`}
                className="w-full h-32 object-cover rounded-lg"
              />
              <button
                type="button"
                onClick={() => handleRemovePhoto(photo?.id)}
                className="absolute top-2 right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <Icon name="X" size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotoUploadSection;